import React from 'react';

import { Box, Button, Card, CardActions, CardMedia, FormGroup, FormHelperText, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';

interface Props {
  onChange: (value: string) => void;
  previousValue?: string;
  value?: string;
  readOnly?: boolean;
}

function VimeoWidget(props: Props) {
  return (
    <Box>
      <TextField
        type="text"
        variant="outlined"
        fullWidth
        value={props.value || ''}
        disabled={props.readOnly}
        onChange={(event) => props.onChange(event.target.value || '')}
      />
      <Box sx={{ mb: '15px' }}>
        {!props.readOnly && (
          <>
            <FormHelperText>Just add the numbers after the .com part of the url, eg:</FormHelperText>
            <img src="/assets/vimeo_help.png" style={{ width: '300px' }} />
          </>
        )}
      </Box>
      {props.value && (
        <FormGroup>
          <Grid size={{ sm: 6 }}>
            <Card sx={{ maxWidth: 560 }}>
              <CardMedia
                sx={{ width: 560 }}
                component="iframe"
                src={`https://player.vimeo.com/video/${props.value}`}
                height="315"
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
              {!props.readOnly && (
                <CardActions>
                  <Button color="error" variant="contained" onClick={() => props.onChange('')}>
                    Delete
                  </Button>
                </CardActions>
              )}
            </Card>
          </Grid>
        </FormGroup>
      )}
    </Box>
  );
}

export default VimeoWidget;
